import { combineReducers } from "redux";
import { VersionReducer } from "./versionReducer";
import themeReducer from "./themeReducer";
import loadingReducer from "./loadingReducers";
import authReducer from "./authReducer";
import accessReducer from "./accessReducer";

const todoApp = combineReducers({
    VersionReducer: VersionReducer,
    theme: themeReducer,
    loading: loadingReducer,
    auth: authReducer,
    access: accessReducer
});

export default todoApp;